import type { EditPortfolioCommandData } from '@festina/unitlink-general-types/unitlink'
import { PortfolioSourcesEventsService } from '@festina/unitlink-general-types/unitlink/services/PortfolioSourcesEventsService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { PortfolioActionProps } from '../types'

const method = PortfolioSourcesEventsService.portfolioSourcesServicePostEvents

export const useCreateEditPortfolio = ({
  ownerId,
  tenantId,
}: PortfolioActionProps) =>
  useFestinaMutation({
    component: 'unitLink',
    roles:
      PortfolioSourcesEventsService.portfolioSourcesServicePostEvents_roles,
    isScenario: false,
    mutateFunction: async (arg: EditPortfolioCommandData) => {
      await method({
        ownerId,
        xTenantId: tenantId,
        requestBody: {
          _type: 'CreatePortfolioCommand',
          commandData: arg,
          commandType: 'editPortfolio',
        },
      })
    },
  })
